//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MillOperationBuilder.js";
import "../CAM/CAM.DrillSurfaceBuilder.js";
let d=[[[0,"AllowOversizeTool",1,0],[1,"BottomSurface",0,"CAM.DrillSurfaceBuilder",0],[0,"CycleType",1,0],[0,"DepthOffsetBlindHole",1,0],[0,"DepthOffsetThruHole",1,0],[0,"MaterialSide",1,0],[0,"MinimumClearance",1,0],[0,"OversizeTool",1,0],[0,"ProjectVectorType",1,0],[0,"ToolAxisType",1,0],[1,"TopSurface",0,"CAM.DrillSurfaceBuilder",0],[0,"UseArcAxis",1,0]],[],[]];
SPLM.CAM.PointToPointBuilder = class extends SPLM.CAM.MillOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PointToPointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.PointToPointBuilder.CycleTypes = Object.freeze({
    "NoCycle" : "NoCycle", "PeckDrill" : "PeckDrill", "BreakChip" : "BreakChip", "StandardText" : "StandardText", "StandardDrill" : "StandardDrill", "StandardDrillCsink" : "StandardDrillCsink", "StandardDrillDeep" : "StandardDrillDeep", "StandardDrillBreakChip" : "StandardDrillBreakChip", "StandardTap" : "StandardTap", "StandardBore" : "StandardBore", "StandardBoreDrag" : "StandardBoreDrag", "StandardBoreNoDrag" : "StandardBoreNoDrag", "StandardBoreBack" : "StandardBoreBack", "StandardBoreManual" : "StandardBoreManual"});

SPLM.CAM.PointToPointBuilder.TlaxisTypes = Object.freeze({
    "None" : "None", "Fixed" : "Fixed", "NormalToPart" : "NormalToPart"});

SPLM.CAM.PointToPointBuilder.ProjectVectorTypes = Object.freeze({
    "None" : "None", "SpecifyVetor" : "SpecifyVetor", "ToolAxis" : "ToolAxis"});

SPLM.CAM.PointToPointBuilder.MaterialSideTypes = Object.freeze({
    "None" : "None", "SpecifyVetor" : "SpecifyVetor", "ToolAxis" : "ToolAxis"});

export default SPLM;